module.exports = __webpack_public_path__ + "img/otter.099fd5d8.png";